module.exports = __webpack_public_path__ + "static/media/office_10@2x.241752ae.jpg";